module.exports = __webpack_public_path__ + "static/media/cashback_wallet_modal_asset_01.c3003819.svg";